import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from 'react';
import { useBKJTimeInputContext } from './BKJTimeInput.context.js';
import { BKJTimeInputItem } from './BKJTimeInputItem.js';
export const BKJTimeInputOptionsMapper = () => {
    const { options, rowVirtualizer, customTimeOption } = useBKJTimeInputContext();
    if (customTimeOption) {
        return _jsx(BKJTimeInputItem, { ...customTimeOption, index: -1 }, customTimeOption.id);
    }
    return (_jsxs(Fragment, { children: [_jsx("li", { role: "presentation", "aria-hidden": "true", style: { height: rowVirtualizer.totalSize } }, "total-size"), rowVirtualizer.virtualItems.map((virtualRow) => {
                const item = options[virtualRow.index];
                return (_jsx(BKJTimeInputItem, { ...item, index: virtualRow.index, style: {
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: virtualRow.size,
                        transform: `translateY(${virtualRow.start}px)`,
                    } }, item.id));
            })] }));
};
//# sourceMappingURL=BKJTimeInputOptionsMapper.js.map